<template>
    <component
        :is="tag"
        :to="to"
        class="c-btn"
        :class="{ 'c-btn--large' : large }"
    >
        <span class="c-btn__label" >
            <slot v-html="label">{{ label }}</slot>
        </span>
    </component>
</template>

<script>/* eslint-disable */

	export default {
        name: 'Btn',
        props: {
            tag: {
                type: String,
                default: 'button'
            },
            to: {
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: 'Button Label'
            },
        }
	}
</script>

<style scoped>
</style>
